import cs from 'classnames';
import React from 'react';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import classNames from './DragHandle.module.scss';

interface DragHandleProps {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
  disabled?: boolean;
  className?: string;
  title?: string;
  testId?: string;
}

export function DragHandle({
  attributes,
  listeners,
  disabled = false,
  className,
  title = 'Drag to reorder',
  testId = 'drag-handle',
}: DragHandleProps) {
  return (
    <span
      className={cs(classNames.dragHandle, disabled && classNames.disabled, className)}
      title={title}
      data-testid={testId}
      {...(disabled ? {} : attributes)}
      {...(disabled ? {} : listeners)}
    >
      ⠿
    </span>
  );
}
